import { createSelector } from 'reselect'
import { State } from 'index'

const calendarSelector = (state: State) => state.calendar

export const getActiveDates = createSelector([calendarSelector], (state) => state.activeDates)
export const getCurrentDate = createSelector([calendarSelector], (state) => state.currentDate)
export const getCurrentMonth = createSelector([calendarSelector], (state) => state.currentMonth)
export const getClosedDates = createSelector([calendarSelector], (state) => state.closedDates)
export const getSpecialHolidays = createSelector([calendarSelector], (state) => state.specialHolidays)
export const getOrderedDates = createSelector([calendarSelector], (state) => state.orderedDates)
